// Polyfills for Intl APIs
import '@formatjs/intl-locale/polyfill.js';
import '@formatjs/intl-getcanonicallocales/polyfill.js';
import '@formatjs/intl-pluralrules/polyfill.js';
import '@formatjs/intl-pluralrules/locale-data/en.js';
import '@formatjs/intl-relativetimeformat/polyfill.js';
import '@formatjs/intl-relativetimeformat/locale-data/en.js';
import '@formatjs/intl-displaynames/polyfill.js';
import '@formatjs/intl-displaynames/locale-data/en.js';

import { createIntl, createIntlCache, type FormatNumberOptions, type IntlCache } from 'react-intl';
import en from '../locales/en.json';

// prevents memory leak
const cache = createIntlCache();

export const defaultDateOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  ...process.env.NODE_ENV === 'test' ? { timeZone: 'utc' } : {}
};

export const dateOnlyOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  ...process.env.NODE_ENV === 'test' ? { timeZone: 'utc' } : {}
};

export const shortDateOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  ...process.env.NODE_ENV === 'test' ? { timeZone: 'utc' } : {}
};

export const uniformDateOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  ...process.env.NODE_ENV === 'test' ? { timeZone: 'utc' } : {}
};

export const longDateOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  ...process.env.NODE_ENV === 'test' ? { timeZone: 'utc' } : {}
};

export const defaultIntegerOptions: FormatNumberOptions = {
  style: 'decimal',
  maximumFractionDigits: 0
};

export const percentageOptions: FormatNumberOptions = {
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
};

export const newIntl = (
  messages?: Record<string, string>,
  customMessages?: Record<string, string>,
  customCache?: IntlCache
) => createIntl({
  locale: 'en',
  messages: {
    ...en,
    ...messages || {},
    ...customMessages || {}
  },
  formats: {
    number: {
      integer: defaultIntegerOptions
    },
    date: {
      numeric: defaultDateOptions
    }
  },
  wrapRichTextChunksInFragment: true
}, customCache || cache);

export const intl = newIntl();
